import React from "react";
import 'babel-polyfill';
import {HashRouter as Router, Route, Switch, Redirect} from "react-router-dom"
import {getFormValues, reduxForm, change, initialize, destroy} from 'redux-form'
import {connect, Provider} from 'react-redux'
import {CompanyContainer} from "./views/account"
import {RegistrationTypeSelectionContainer} from './views/landing'
import {RegistrationFormContainer} from "./views/register"
import {NoAccountFormContainer} from "./views/noaccount";
import {Registration as _Registration} from "./views/registration"
import {store} from "./configureReduxForm"
import InitialState from "./initialstate"
import {Errors} from "./api/util"
import {AnalyticEvent, DirectCall} from "./components/forms"
import scrollIntoViewIfNeeded from "scroll-into-view-if-needed";
import ReactDOM from "react-dom";

let Registration = connect(state => {
    return {
        error: state.applicationErrors

    }
})(_Registration);

class RegistrationComplete extends React.Component {

    componentDidMount = () => {
        scrollIntoViewIfNeeded(ReactDOM.findDOMNode(this._registrationCompleteNode), false , {duration: 150});
    };

    componentWillUnmount = () => {
        this.props.dispatch(change('wizard', 'renderComplete', false));
    };

    render = () => {
        return <Registration ref={(node) => { this._registrationCompleteNode = node}} handleNavigationClick={() => {}} active={3}/>
    }

}

RegistrationComplete = connect(state => {
    return {
        wizard: getFormValues('wizard')(state)
    }
})(RegistrationComplete);

const initFormData = (dispatch) => {
    dispatch(initialize('registration', InitialState.registration));
    dispatch(initialize('account', InitialState.account));
    dispatch(initialize('international/agent', InitialState.international.agent));
    dispatch(initialize('international/company', InitialState.international.company));
    dispatch(initialize('existingcompany', InitialState.existingcompany));
    dispatch(initialize('domestic/existingcustomer', InitialState.domestic.existingcustomer));
    dispatch(initialize('domestic/groundhandler', InitialState.domestic.groundhandler));
    dispatch(initialize('domestic/new/company', InitialState.domestic['new'].company));
    dispatch(initialize('domestic/new/customer', InitialState.domestic['new'].customer));

    dispatch(initialize('wizard', {
        complete: false,
        renderComplete: true,
        steps: [
            {complete: false},
            {complete: false},
            {complete: false},
            {complete: false},
        ]
    }));
};

const destroyFormData = (dispatch) => {
    dispatch(destroy('registration'));
    dispatch(destroy('account'));
    dispatch(destroy('international/agent'));
    dispatch(destroy('international/company'));
    dispatch(destroy('existingcompany'));
    dispatch(destroy('domestic/existingcustomer'));
    dispatch(destroy('domestic/groundhandler'));
    dispatch(destroy('domestic/new/company'));
    dispatch(destroy('domestic/new/customer'));
};


class Application extends React.Component {


    componentWillMount = () => {
        initFormData(this.props.dispatch)
    };

    account = (props) => {
        this.props.registration['hasaccount']['value'] ? props.history.push('/registration/account') : props.history.push('/registration/no-account');
    };


    complete = (props) => {
        destroyFormData(this.props.dispatch);
    };


    render = () => {
        const wizard = this.props.wizard;
        const hasaccount = this.props.registration.hasaccount.value;
        return (
            <Router>
                <Switch>
                    <Route exact path="/" render={(props) =>

                        <RegistrationTypeSelectionContainer onRegisterClick={() => {
                            if (wizard.complete) initFormData(this.props.dispatch);
                            this.props.dispatch(change('wizard', 'steps[0].complete', true));
                            AnalyticEvent(window.dataLayer, {
                                "eventInfo": {
                                    "eventName": "registrationStep2",
                                    "eventAction": "1",
                                }
                            }).then(()=> {}, () => {});
                            props.history.push('/registration');
                        }}/>}
                    />


                    <Route exact path="/registration" render={(props) => {
                        if (wizard.steps[0].complete && !wizard.complete) {
                            return (
                                <Registration active={0}>
                                    <RegistrationFormContainer
                                        path={props.location.pathname}
                                        handleSubmitSuccess={(result, dispatch, p) => {
                                            dispatch(change('wizard', 'steps[1].complete', true));
                                            dispatch(Errors.clear());
                                            AnalyticEvent(window.dataLayer, {
                                                "eventInfo": {
                                                    "eventName": "registrationStep3",
                                                },

                                                "attributes": {
                                                }
                                            }).then(() => {
                                                return DirectCall(window._satellite, "registrationStep3")
                                            }).then();
                                            this.account(props);

                                        }}/>
                                </Registration>
                            )
                        }
                        else {
                            return <Redirect to={"/"}/>
                        }

                    }}/>


                    {
                        <Route exact path="/registration/account" render={(props) => {

                            if (wizard.steps[1].complete && !wizard.complete && hasaccount) {
                                return (<Registration active={1}>
                                    <CompanyContainer
                                        path={props.location.pathname}
                                        handleRedirectToNoAccount={() => {
                                            props.history.push("/registration/no-account")
                                        }}
                                        handleSubmitSuccess={(results, dispatch, p) => {
                                            dispatch(Errors.clear());
                                            dispatch(change('wizard', 'steps[2].complete', true));
                                            dispatch(change('wizard', 'steps[3].complete', false));
                                            dispatch(change('wizard', 'complete', true));
                                            dispatch(change('wizard', 'renderComplete', true));
                                            props.history.push("/registration/complete")
                                        }}/>
                                </Registration>)
                            }
                            else {
                                return <Redirect to={"/"}/>

                            }

                        }}/>
                    }

                    {
                        <Route exact path="/registration/no-account" render={(props) => {

                            if (wizard.steps[1].complete && !wizard.complete && !hasaccount) {
                                return (
                                    <Registration active={1}>
                                        <NoAccountFormContainer
                                            path={props.location.pathname}

                                            handleSubmitSuccess={(results, dispatch, p) => {
                                                dispatch(Errors.clear());
                                                dispatch(change('wizard', 'steps[3].complete', true));
                                                dispatch(change('wizard', 'steps[2].complete', false));
                                                dispatch(change('wizard', 'complete', true));
                                                dispatch(change('wizard', 'renderComplete', true));
                                                props.history.push("/registration/complete")
                                            }}/>
                                    </Registration>)
                            }
                            else {
                                return <Redirect to={"/"}/>
                            }
                        }}/>
                    }

                    <Route exact path="/registration/complete" active={3} render={(props) => {
                        if (wizard.complete && wizard.renderComplete) {
                            return <RegistrationComplete/>
                        }
                        else {
                            return <Redirect to={"/"}/>
                        }
                    }

                    }/>)

                    <Redirect to={"/"}/>

                </Switch>
            </Router>

        )
    }

}


Application = connect((state) => {
    return {
        wizard: getFormValues('wizard')(state),
        config: getFormValues('config')(state),
        existingcompany: getFormValues('existingcompany')(state),
        registration: getFormValues('registration')(state) || {hasaccount: {value: undefined, label: ""}},
        international: {
            company: getFormValues('international/company')(state),
            agent: getFormValues('international/agent')(state),
        },
        domestic: {
            existingcustomer: getFormValues('domestic/existingcustomer')(state),
            groundhandler: getFormValues('domestic/groundhandler')(state),
            newcustomer: {
                "company": getFormValues('domestic/new/company')(state),
                "customer": getFormValues('domestic/new/customer')(state),
            }
        },
        account: getFormValues('account')(state),
        applicationErrors: state.applicationErrors || {submitted: false}
    }

})(reduxForm({form: 'application'})(Application));

class RegistrationApplication extends React.Component {

    componentWillMount = () => {
        store.dispatch(initialize('config', this.props.config));
        store.dispatch(initialize('wizard',
            {
                complete: false,
                renderComplete: true,
                steps: [
                    {complete: false},
                    {complete: false},
                    {complete: false},
                    {complete: false}
                ]
            }));

    };

    render = () => {
        return <Provider store={store}><Application config={this.props.config}/></Provider>
    }

}

RegistrationApplication.defaultProps = {
    config: {

        terms: {
            url: 'http://www.qantas.com/travel/airlines/terms-of-use/global/en'
        },
        policy: {
            url: 'http://www.qantas.com/travel/airlines/privacy/global/en'
        },
        customer: {
            url: 'http://localhost:3001'
        },
        userreg: {
            url: 'http://localhost:3001'
        },
        userprof: {
            url: 'http://localhost:3001'
        },
        refdata: {
            url: 'http://localhost:3001'
        }
    }
};

export {
    RegistrationApplication
}